import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const FeedDetailHeader = styled.div`
    display: flex;
    align-items: center;
    padding: calc(100vw * (16.5 / 375)) calc(100vw * (17 / 375)) calc(100vw * (13 / 375));
    background: inherit;
`;

export const FeedUserInfo = styled(Link)``;

export const FeedUserImgArea = styled.div`
    width: calc(100vw * (42 / 375));
    height: calc(100vw * (42 / 375));
    border-radius: 50%;
    overflow: hidden;
    border: solid calc(100vw * (1 / 375)) #c6c6c6;
`;

export const FeedUserImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`

export const FeedTopInfoArea = styled.div`
    margin-left: calc(100vw * (7 / 375));
    width: 85%;
`;

export const FeedUserName = styled.span`
    font-size: calc(100vw * (14 / 375));
    font-weight: bold;  
`;

export const FeedDescription = styled.p`
    width: 90%;
    font-size: calc(100vw * (14 / 375));
    font-weight: 500;
    color: #535353;
    margin-top: calc(100vw * (2 / 375));
`;